import { render, staticRenderFns } from "./ChatFiltersConfig.vue?vue&type=template&id=c64cd14a&scoped=true&"
import script from "./ChatFiltersConfig.vue?vue&type=script&lang=ts&"
export * from "./ChatFiltersConfig.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFiltersConfig.vue?vue&type=style&index=0&id=c64cd14a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64cd14a",
  null
  
)

export default component.exports